module.exports = __webpack_public_path__ + "static/img/2_2_3_1.c08188c9.jpg";